import { map,wrap } from '@codeArt/utils/promise';
import { type } from '../utils/common';

const _ = require("lodash");
function Runtime(){

    const instances = {};

    this.addExtension = (id,instance)=>{ //运行时添加的扩展实例
        instances[id] = instance;
    }

    this.getExtension = (id)=>{
        return instances[id];
    }

    this.removeExtension = (id)=>{
        return wrap((resolve, reject) => {
            let instance = instances[id];
            if(!instance) resolve();
            const {deactivate,exacts} = instance;
           
            deContributes(exacts).then(()=>{ //撤回贡献点
                map(deactivate).then(resolve).catch(reject);    //执行插件的销毁函数
            }).catch(reject);
        });
    }

    const deContributes = (exacts)=>{ //撤回贡献点
        return wrap((resolve, reject) => {
            if(!exacts || exacts.length===0) return resolve();
            Promise.all(exacts.map((e)=> map(e))).then(resolve).catch(reject);
        });
    }

}

export {Runtime};